<div *ngIf="isPageReady" id="approvalTreeDialog" class="flex flex-col h-full w-full">
  <div class="flex flex-col gap-4 mb-4">
    <prox-field label="Name *">
      <input id="atName" pInputText [disabled]="isReadOnly()" [(ngModel)]="approvalTree.name" class="w-full"
        maxlength="100" />
    </prox-field>

    <prox-field label="Description *">
      <textarea id="atDescription" pInputTextarea [disabled]="isReadOnly()" [(ngModel)]="approvalTree.description"
        class="w-full" rows="5" maxlength="500" placeholder="Enter description here..."></textarea>
    </prox-field>

    <div class="mt-2">
      <div class="qb-group-label">Program-Specific Tree</div>
      <p class="text-sm mb-2">
        Most Organization Trees describe who approves whom, and are shared by any number of Programs. Mark this tree
        program-specific only when one Program needs its own settings on each Program User Group &mdash; a different
        purchase order per group, for instance. A program-specific tree serves a single Program, and its group settings
        belong to that Program alone.
      </p>
      <div>
        <p-checkbox id="atIsProgramSpecific" [disabled]="isReadOnly() || isCheckingDesignation"
          [(ngModel)]="approvalTree.isProgramSpecific" [binary]="true"
          (onChange)="onIsProgramSpecificChanged()"></p-checkbox>
        <label for="atIsProgramSpecific" class="ml-2">This tree serves one Program and may carry its group settings</label>
      </div>
      <div *ngIf="isCheckingDesignation" class="text-sm mt-2">Checking which Programs use this tree&hellip;</div>
    </div>
  </div>

  <div class="flex pt-2 items-center">
    <p-button *ngIf="!isReadOnly()" id="atSave" [disabled]="!canSave()" (onClick)="onSave()"
      label="Save" icon="pi pi-check" styleClass="mr-2"></p-button>
    <p-button (onClick)="onCancel()" [label]="cancelLabel()" icon="pi pi-times"
      styleClass="mr-2"></p-button>
    <div class="flex-grow"></div>
    <p-button (onClick)="onShowInsights()" label="Insights" icon="fa-duotone fa-lightbulb"
      styleClass="qb-insights-button" [rounded]="true"
      pTooltip="Guide Me: Tips & strategies for setting up your Organization Tree" tooltipPosition="left"></p-button>
  </div>
</div>